module.exports = __webpack_public_path__ + "static/media/add.ebdf7a5a.svg";